import React, { useEffect } from "react";
import { loadTags, loadScripts, sendRps } from "../../helpers/http";

export const Tracking = ({ page }) => {
    useEffect(() => {
      loadTags(page, loadScripts);
      sendRps();
    
  }, []);

  return (
    <>
    </>
  )
}
